import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactInvitationInputModel } from '../models/contact-invitation.model';
import { Observable, Subject } from 'rxjs';
import { ContactInvitationApprovedResultModel } from '../models/contact-invitation-approved-result.model';

@Injectable({
  providedIn: 'root'
})
export class ContactInvitationService {

  private _contactInvitationValidityResult: Subject<string | null> = new Subject<string | null>();
  public contactInvitationValidityResult: Observable<string | null> = this._contactInvitationValidityResult.asObservable();

  private _pinCodeValidationResult: Subject<boolean> = new Subject<boolean>();
  public pinCodeValidationResult: Observable<boolean> = this._pinCodeValidationResult.asObservable();

  private _contactInviationApprovalResult: Subject<ContactInvitationApprovedResultModel | null> = new Subject<ContactInvitationApprovedResultModel | null>();
  public contactInviationApprovalResult: Observable<ContactInvitationApprovedResultModel | null> = this._contactInviationApprovalResult.asObservable();

  
  constructor(private http: HttpClient) {

  }

  /* contact invitation functions */

  /* anonymous function - check if contact invitation is valid */
  public checkContactInvitationValidity(contactInvitationId: string, contactInvitationType: number) {
    this.http.get<string | null>('/api/contactinvitation/' + contactInvitationId + '/type/' + contactInvitationType)
    .subscribe(
      (data: string | null) => {        
        this._contactInvitationValidityResult.next(data);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
        console.log('Finished loading contactinvitation ' + contactInvitationId);
      }
    )
  }

  /* anonymous function - check if contact invitation PIN code is valid */
  public validatePinCode(contactInvitationId: string, pinCode: string) {
    this.http.get<boolean>('/api/contactinvitation/' + contactInvitationId + '/' + pinCode)
    .subscribe(
      (result: boolean) => {      
        this._pinCodeValidationResult.next(result);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
        console.log('Finished validating PIN ' + pinCode);
      }
    )
  }

  /* anonymous function - update contact invitation with status 1=approved, 2=rejected */
  public setContactInvitationStatus(contactInvitationId: string, status: number) {
    return this.http.put<number>('/api/contactinvitation/' + contactInvitationId, status);
  }
  
  /* authorized functions */
  public checkContactInvitationApproveStatus(contactInvitationId: string, caseUid: string) {
    this.http.get<ContactInvitationApprovedResultModel | null>('/api/contactinvitation/' + contactInvitationId + '/' + caseUid + '/approvestatus')
    .subscribe(
      (result: ContactInvitationApprovedResultModel | null) => {        
        this._contactInviationApprovalResult.next(result);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
        console.log('Finished checking contact invitation approval status');
      }
    )
  }

  public settleContactInvitation(input: ContactInvitationApprovedResultModel, contactInvitationId: string, caseUid: string) {
    return this.http.post('/api/contactinvitation/' + contactInvitationId + '/' + caseUid + '/settle', input)
  }
  
  
  public addContactInvitation(contactInvitationInput: ContactInvitationInputModel, caseUid: string) {
    return this.http.post('/api/contactinvitation/add/' + caseUid, contactInvitationInput);
  }
  
  public addComplainerInvitation(caseUid: string) {
    return this.http.post('/api/contactinvitation/addaccess/' + caseUid, undefined);
  }
  

  public removeContact(caseUid: string) {
    return this.http.post('/api/case/removecontact/' + caseUid, null);
  }

  
}
